import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ScheduleTypeEnum } from '@/tools/enums/schedule-type.enum';
import { ScheduleService } from '@/tools/services/schedule.service';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';

interface ScheduleOption {
  value: string;
  label: string;
}

@Component({})
export default class EdClassScheduleSelectTypeModal extends Vue {
  @Prop({ type: Number, required: true }) readonly classId!: number;
  @Prop({ type: Function, required: true }) readonly onContinue!: (scheduleType: ScheduleTypeEnum) => void;

  public selectedScheduleType = ScheduleTypeEnum.WEEK;
  public isSaving = false;

  get scheduleOptions(): ScheduleOption[] {
    return [
      { value: ScheduleTypeEnum.AB, label: 'ab' },
      { value: ScheduleTypeEnum.WEEK, label: 'weekly' }
    ];
  }

  public async continueSelection(): Promise<void> {
    try {
      if (this.selectedScheduleType) {
        this.isSaving = true;
        await this.onContinue(this.selectedScheduleType);
      }
  
      this.$EdModal.closeModal();
    } catch (error) {
      this.$EdToast.create({
        msg: this.$t('tools.classBuilder.errorSavingScheduleType') as string,
        type: TOAST_TYPES.DANGER,
        timeout: 3000
      });
    } finally {
      this.isSaving = false;
    }
  }

  public cancelSelection(): void {
    this.$EdModal.closeModal();
  }
}
